/* eslint-disable import/no-default-export */
import { MockList } from '@graphql-tools/mock';
import Chance from 'chance';

const chance = new Chance();

const roleTitles = [
  'Assistant',
  'Barista',
  'Cook',
  'Driver',
  'Electrician',
  'Finance Manager',
  'General Manager',
  'Head Chef',
  'Quality Analyst',
  'Senior Accountant',
  'Waitperson',
  'Welder',
];

export default () => {
  const roleTitle = chance.pickone(roleTitles);
  const seniority = chance.pickone(['Senior', 'Junior']);

  return {
    id: `http://graph.seek.com/role-title/${chance.integer({
      min: 0,
      max: 9999,
    })}`,
    matchedVariant: roleTitle,
    normalisedText: roleTitle,
    seniorityId: `http://graph.seek.com/seniority/${seniority}`,
    matchedRoleTitleVariant: roleTitle,
    matchedSeniorityVariant: seniority,
    highlights: () => new MockList([0, 1]),
  };
};
